import React from 'react';
import { createComponent } from '@workday/canvas-kit-react/common';
import { Popup } from '@workday/canvas-kit-react/popup';
export const ToastCloseIcon = createComponent('button')({
    displayName: 'Toast.CloseIcon',
    Component: (elemProps, ref, Element) => {
        return (React.createElement(Popup.CloseIcon, Object.assign({ as: Element, ref: ref, size: "small", position: "relative" }, elemProps)));
    },
});
